(function () {
/**
 * Faixas de CEP por UF (alinhado a assets/get-estimates-product.js).
 */
const CEP_BR_RANGES = {
  Acre: [{ start: 69900000, end: 69999999 }],
  Alagoas: [{ start: 57000000, end: 57999999 }],
  Amapá: [{ start: 68900000, end: 68999999 }],
  Amazonas: [
    { start: 69000000, end: 69299999 },
    { start: 69400000, end: 69899999 },
  ],
  Bahia: [{ start: 40000000, end: 48999999 }],
  Ceará: [{ start: 60000000, end: 63999999 }],
  'Distrito Federal': [
    { start: 70000000, end: 72799999 },
    { start: 73000000, end: 73699999 },
  ],
  'Espírito Santo': [{ start: 29000000, end: 29999999 }],
  Goiás: [
    { start: 72800000, end: 72999999 },
    { start: 73700000, end: 76799999 },
  ],
  Maranhão: [{ start: 65000000, end: 65999999 }],
  'Mato Grosso': [{ start: 78000000, end: 78899999 }],
  'Mato Grosso do Sul': [{ start: 79000000, end: 79999999 }],
  'Minas Gerais': [{ start: 30000000, end: 39999999 }],
  Pará: [{ start: 66000000, end: 68899999 }],
  Paraíba: [{ start: 58000000, end: 58999999 }],
  Paraná: [{ start: 80000000, end: 87999999 }],
  Pernambuco: [{ start: 50000000, end: 56999999 }],
  Piauí: [{ start: 64000000, end: 64999999 }],
  'Rio de Janeiro': [{ start: 20000000, end: 28999999 }],
  'Rio Grande do Norte': [{ start: 59000000, end: 59999999 }],
  'Rio Grande do Sul': [{ start: 90000000, end: 99999999 }],
  Rondônia: [{ start: 76800000, end: 76999999 }],
  Roraima: [{ start: 69300000, end: 69399999 }],
  'Santa Catarina': [{ start: 88000000, end: 89999999 }],
  'São Paulo': [{ start: parseInt('01000000', 10), end: 19999999 }],
  Sergipe: [{ start: 49000000, end: 49999999 }],
  Tocantins: [{ start: 77000000, end: 77999999 }],
};

function getBrazilStateFromCep(zipRaw) {
  const cep = String(zipRaw).replace(/\D/g, '');
  if (cep.length !== 8) return '';
  const n = parseInt(cep, 10);
  for (const estado of Object.keys(CEP_BR_RANGES)) {
    for (const range of CEP_BR_RANGES[estado]) {
      if (n >= range.start && n <= range.end) return estado;
    }
  }
  return '';
}

function setProvinceSelectByValue(selectEl, value) {
  if (!selectEl || !value) return;
  Array.from(selectEl.options).forEach((option, index) => {
    if (option.value === value || option.innerHTML === value) {
      selectEl.selectedIndex = index;
    }
  });
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return '';
}

function updateCartCookie(value) {
  const date = new Date();
  date.setTime(date.getTime() + 14 * 86400000);
  document.cookie = `cart=${value}; expires=${date.toGMTString()}; path=/`;
}

if (!customElements.get('shipping-calculator')) {
  class ShippingCalculator extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.initialised) this.init();
      });
    }

    init() {
      if (this.initialised) return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.button.addEventListener('click', this.handleSubmit.bind(this));
      this.country = this.querySelector('.js-country-select');
      this.province = this.querySelector('.js-province-select');
      this.zip = this.querySelector('.js-zip-input');
      this.rates = this.querySelector('.js-rates');
      this.errors = this.querySelector('.js-errors');
      this.productMode = this.dataset.productMode === 'true';

      const syncProvinceFromCep = () => {
        if (!this.country || this.country.value !== 'Brazil' || !this.zip || !this.province) return;
        const digits = this.zip.value.replace(/\D/g, '');
        if (digits.length !== 8) return;
        const state = getBrazilStateFromCep(this.zip.value);
        if (state) setProvinceSelectByValue(this.province, state);
      };

      if (this.zip) {
        this.zip.addEventListener('blur', syncProvinceFromCep);
        let cepDebounce;
        this.zip.addEventListener('input', () => {
          clearTimeout(cepDebounce);
          cepDebounce = setTimeout(syncProvinceFromCep, 400);
        });
      }

      if (this.country) {
        this.country.addEventListener('change', () => {
          if (this.country.value === 'Brazil') syncProvinceFromCep();
        });
      }

      this.initialised = true;
    }

    getSelectedVariantId() {
      const productInfo = this.closest('product-info') || document;
      const variantInput =
        productInfo.querySelector('.main-product-form [name="id"]') ||
        productInfo.querySelector('form[data-type="add-to-cart-form"] [name="id"]') ||
        productInfo.querySelector('[name="id"]');

      if (!variantInput || !variantInput.value) return null;
      const variantId = parseInt(variantInput.value, 10);
      return Number.isNaN(variantId) ? null : variantId;
    }

    getSelectedQuantity() {
      const productInfo = this.closest('product-info') || document;
      const qtyInput =
        productInfo.querySelector('.quantity__input') ||
        productInfo.querySelector('[name="quantity"]');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
    }

    getCartUrl() {
      if (this.dataset.cartUrl) return this.dataset.cartUrl.replace(/\/$/, '');
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return `${window.Shopify.routes.root.replace(/\/$/, '')}/cart`;
      }
      return '/cart';
    }

    async fetchShippingRates() {
      const params = new URLSearchParams({
        'shipping_address[zip]': this.zip.value,
        'shipping_address[country]': this.country.value,
        'shipping_address[province]': this.province.value,
      });

      const response = await fetch(`${this.getCartUrl()}/shipping_rates.json?${params}`);
      const data = await response.json();
      return { response, data };
    }

    async fetchProductShippingRates(variantId) {
      const cartUrl = this.getCartUrl();
      let originalCartCookie = getCookie('cart');
      const tempCookieValue = `temp-cart-cookie___${Date.now()}`;
      const fakeCookieValue = `fake-cart-cookie___${Date.now()}`;

      if (!originalCartCookie) {
        updateCartCookie(tempCookieValue);
        originalCartCookie = getCookie('cart');
      }

      if (!originalCartCookie || originalCartCookie.length < 32) {
        throw new Error('Carrinho inválido para cálculo de frete.');
      }

      updateCartCookie(fakeCookieValue);

      try {
        const addResponse = await fetch(`${cartUrl}/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: this.getSelectedQuantity(),
          }),
        });
        const addData = await addResponse.json();

        if (addData && addData.status && addData.status >= 400) {
          throw new Error('Não foi possível calcular o frete. Verifique se o produto está disponível.');
        }

        return await this.fetchShippingRates();
      } finally {
        updateCartCookie(originalCartCookie);
      }
    }

    /**
     * Handles submission of the rates calculator.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      evt.preventDefault();
      if (!this.initialised) this.init();
      if (!this.zip || !this.country || !this.province) return;

      if (this.errors) this.errors.hidden = true;
      if (this.rates) this.rates.hidden = true;
      this.setLoading(true);

      try {
        if (this.country.value === 'Brazil') {
          const cepDigits = this.zip.value.replace(/\D/g, '');
          if (cepDigits.length !== 8) {
            this.showErrors({ zip: 'O CEP deve ter 8 dígitos.' });
            return;
          }
          const stateFromCep = getBrazilStateFromCep(this.zip.value);
          if (!stateFromCep) {
            this.showErrors({ zip: 'CEP inválido ou não encontrado. Verifique o CEP digitado.' });
            return;
          }
          setProvinceSelectByValue(this.province, stateFromCep);
        }

        let result;

        if (this.productMode) {
          const variantId = this.getSelectedVariantId();
          if (!variantId) {
            this.showErrors({ variant: 'Selecione uma opção do produto antes de calcular o frete.' });
            return;
          }
          result = await this.fetchProductShippingRates(variantId);
        } else {
          result = await this.fetchShippingRates();
        }

        if (result.response.ok) {
          this.showRates(result.data);
        } else {
          this.showErrors(result.data);
        }
      } catch (error) {
        this.showErrors({ error: error.message || 'Não foi possível calcular o frete. Tente novamente.' });
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(isLoading) {
      const spinner = this.button.querySelector('.loading__spinner, .svg-loader');
      const buttonText = this.button.querySelector('.button-text');

      this.button.disabled = isLoading;
      this.button.classList.toggle('is-loading', isLoading);

      if (buttonText) {
        buttonText.classList.toggle('hidden', isLoading);
      }

      if (spinner) {
        spinner.classList.toggle('hidden', !isLoading);
        spinner.style.display = isLoading ? 'block' : 'none';
      }
    }

    /**
     * Formats and shows a list of available shipping rates.
     * @param {object} data - Response data.
     */
    showRates(data) {
      const headingEl = this.rates.querySelector('.js-rates-heading');
      const textEl = this.rates.querySelector('.js-rates-text');
      textEl.innerHTML = '';

      if (data.shipping_rates && data.shipping_rates.length) {
        const headingText = data.shipping_rates.length === 1 ? 'Opção de frete disponível:' : 'Opções de frete disponíveis:';
        let rates = '';

        data.shipping_rates.forEach((rate) => {
          let formattedRate;
          if (rate.price > 0) {
            formattedRate = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(rate.price);
          } else {
            formattedRate = 'Frete Grátis'
          }

          let deliveryInfo = '';

          if (rate.name === 'Local Delivery' || rate.code === 'Local Delivery') {
            deliveryInfo = rate.description || '';
          } else if (Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
            deliveryInfo = rate.delivery_days[0] === 1
              ? '1 dia útil'
              : `${rate.delivery_days[0]} dias úteis`;
          }

          rates += `<li><p>${rate.name === 'Local Delivery' ? 'Entrega local' : rate.name}: <b>${formattedRate}</b></p>${deliveryInfo ? `<p class="delivery-time">${deliveryInfo}</p>` : ''}</li>`;
        });

        headingEl.hidden = false;
        headingEl.textContent = headingText;
        textEl.innerHTML = `<ul class="styled-list">${rates}</ul>`;
      } else {
        headingEl.hidden = true;
        textEl.innerHTML = '<p>Nenhuma opção de frete disponível para este endereço.</p>';
      }

      this.rates.hidden = false;
    }

    /**
     * Formats and shows errors relating to rates retrieval.
     * @param {object} data - Response data.
     */
    showErrors(data) {
      let errors = '';

      Object.keys(data).forEach((key) => {
        errors += `<li>${data[key]}</li>`;
      });

      this.errors.querySelector('.js-errors-text').innerHTML = `<ul class="styled-list">${errors}</ul>`;
      this.errors.hidden = false;
    }
  }

  customElements.define('shipping-calculator', ShippingCalculator);
}
})();
